import { memo } from 'react';

export const CasinoSkeleton = memo(() => {
  return (
    <div
      className="flex justify-center items-center gap-4"
      role="status"
      aria-label="Cargando juegos de casino"
    >
      {Array.from({ length: 3 }, (_, index) => {
        return (
          <div key={`skeleton-${index}`} className="flex flex-col items-center">
            <div className="w-[140px] h-[140px] md:w-[200px] md:h-[200px] bg-default-100 rounded-lg animate-[fade_1.5s_ease-in-out_infinite] mb-2" />
            <div className="w-20 h-3 bg-default-100 rounded animate-[fade_1.5s_ease-in-out_infinite] mb-1" />
            <div className="w-16 h-3 bg-default-100 rounded animate-[fade_1.5s_ease-in-out_infinite]" />
          </div>
        );
      })}
    </div>
  );
});
